import { render, staticRenderFns } from "./ColumnInsight.vue?vue&type=template&id=5d37e4bc&scoped=true"
import script from "./ColumnInsight.vue?vue&type=script&lang=js"
export * from "./ColumnInsight.vue?vue&type=script&lang=js"
import style0 from "./ColumnInsight.vue?vue&type=style&index=0&id=5d37e4bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d37e4bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d37e4bc')) {
      api.createRecord('5d37e4bc', component.options)
    } else {
      api.reload('5d37e4bc', component.options)
    }
    module.hot.accept("./ColumnInsight.vue?vue&type=template&id=5d37e4bc&scoped=true", function () {
      api.rerender('5d37e4bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/List/ColumnInsight.vue"
export default component.exports